import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Stack,
  Typography,
} from "@mui/material";

const PodcastModal = ({ open, onClose }) => {
  const videoLink = "https://youtu.be/qHWpHS-gv1I?si=URpnB_W2q3mBrfq_";
  const shortsLink =
    "https://youtube.com/shorts/9fnKYv86JEg?si=ihccG4C_5JhqjktM";

  const openLink = (url) => {
    window.open(url, "_blank");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle textAlign="center">Podcast</DialogTitle>

      <DialogContent>
        <Typography align="center" mb={3}>
          Choose what you want to watch
        </Typography>

        <Stack spacing={2}>
          <Button variant="contained" onClick={() => openLink(videoLink)}>
            Videos
          </Button>

          <Button variant="outlined" onClick={() => openLink(shortsLink)}>
            Shorts
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default PodcastModal;
